import React from 'react'
import { Link } from 'react-router-dom'
import BadgeUI from '../../../widgets/output/BadgeUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import './ClientTxnCatTotalList.css'

const ClientTxnCatTotalListUI = ({ context, account, financialYear, categoryTotalList, manualOnly, allAuto }) =>
  <div className='su_cat_totals'>
    <table><tbody>
      <tr>
        <td />
        {
          categoryTotalList.length && categoryTotalList[0].financialYearList.map((yearData, i) =>
            <React.Fragment key={i}>
              <td className='g_text_center spacer_left'>
                <b>{yearData.financialYear}</b>
              </td>
              {
                manualOnly &&
                <td className='g_muted g_text_right'>manual%</td>
              }
              <td />
            </React.Fragment>
          )
        }
      </tr>
      {
        categoryTotalList.map((category, i) =>
          <TxnRowUI key={i} context={context} account={account} category={category}
            manualOnly={manualOnly} allAuto={allAuto}
          />
        )
      }
    </tbody></table>
  </div>

const TxnRowUI = ({ context, account, category, manualOnly, allAuto }) =>
  <React.Fragment>
    <tr>
      <td>{category.categoryLabel}</td>
      {
        category.financialYearList.map((yearData, i) =>
          <React.Fragment key={i}>
            {
              !['all_debits', 'all_credits', 'trade_debits', 'trade_credits'].includes(category.category) &&
              <td className='g_text_right g_p_top_100'>
                {
                  !manualOnly && !allAuto &&
                  <Link to={`/su/accounts/${account.accountId}/clientTxnCatTransactions/${category.category}/${yearData.financialYear}`}>
                    {`${yearData.total < 0 ? '(' : ''}${yearData.total ? yearData.totalF2 : ''}${yearData.total < 0 ? ')' : ''}`}
                  </Link>
                }
                {
                  manualOnly &&
                  <div className='g_error'>
                    {`${yearData.total < 0 ? '(' : ''}${yearData.total ? yearData.manualTotalF2 : ''}${yearData.total < 0 ? ')' : ''}`}
                  </div>
                }
                {
                  allAuto &&
                  <>
                    <span className='g_ultra_muted'>{`${yearData.total < 0 ? '(' : ''}${yearData.total ? yearData.totalF2 : ''}${yearData.total < 0 ? ')' : ''}`}</span>
                    <div className='g_info2'>{yearData.autoTotal < 0 ? `(${yearData.autoTotalF2})` : yearData.autoTotalF2}</div>
                  </>
                }
              </td>
            }
            {
              ['all_debits', 'all_credits', 'trade_debits', 'trade_credits'].includes(category.category) &&
              <td className='g_text_right g_p_top_100'>
                {
                  !manualOnly && !allAuto &&
                  <>{`${yearData.total < 0 ? '(' : ''}${yearData.total ? yearData.totalF2 : ''}${yearData.total < 0 ? ')' : ''}`}</>
                }
                {
                  manualOnly &&
                  <div className='g_error'>
                    {`${yearData.total < 0 ? '(' : ''}${yearData.total ? yearData.manualTotalF2 : ''}${yearData.total < 0 ? ')' : ''}`}
                  </div>
                }
                {
                  allAuto &&
                  <>
                    <span className='g_ultra_muted'>{`${yearData.total < 0 ? '(' : ''}${yearData.total ? yearData.totalF2 : ''}${yearData.total < 0 ? ')' : ''}`}</span>
                    <div className='g_info2'>{yearData.autoTotal < 0 ? `(${yearData.autoTotalF2})` : yearData.autoTotalF2}</div>
                  </>
                }
              </td>
            }
            {
              manualOnly &&
              <td className='g_text_right g_error g_p_top_100'>
                {yearData.manualAmountPercent}{yearData.manualAmountPercent ? '%' : ''}
              </td>
            }
            {
              <td className='g_text_right g_ultra_muted g_p_top_100'>
                {
                  !manualOnly &&
                  <>{yearData.count}</>
                }
                {
                  manualOnly &&
                  <div className='g_error'>{yearData.manualCount}</div>
                }
              </td>
            }
          </React.Fragment>
        )
      }
    </tr>
    {
      category.financialYearList.map((yearData, j) =>
        <Formula key={j} yearData={yearData} />
      )
    }
  </React.Fragment>

const Formula = ({ yearData }) =>
  <>
    {
      yearData.formula &&
      <tr><td colSpan='10' className='g_muted g_small'>
        {yearData.financialYear}: {yearData.formula}
      </td></tr>
    }
  </>

export default ClientTxnCatTotalListUI
